// extracted by mini-css-extract-plugin
export default {"__chip":"StatusChip___chip__FYYXm"};